module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image8b.84ea8769.jpg";